(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["birthday-sale-tracksuit-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCountdown(el) {
    if (el.dataset.countdownInit === 'true') return;

    var end = new Date(el.dataset.endDate).getTime();
    if (isNaN(end)) return;

    var daysEl = el.querySelector('[data-cd-days]');
    var hoursEl = el.querySelector('[data-cd-hours]');
    var minsEl = el.querySelector('[data-cd-mins]');
    var secsEl = el.querySelector('[data-cd-secs]');
    if (!daysEl || !hoursEl || !minsEl || !secsEl) return;

    el.dataset.countdownInit = 'true';

    var timer = null;

    function tick() {
      var diff = Math.max(0, end - Date.now());

      daysEl.textContent = String(Math.floor(diff / 86400000));
      hoursEl.textContent = String(Math.floor((diff % 86400000) / 3600000));
      minsEl.textContent = String(Math.floor((diff % 3600000) / 60000));
      secsEl.textContent = String(Math.floor((diff % 60000) / 1000));

      if (diff > 0) {
        timer = setTimeout(tick, 1000);
      } else if (timer) {
        clearTimeout(timer);
      }
    }

    tick();
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-birthday-sale-countdown]').forEach(initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Re-initialise when the section is re-rendered in the theme editor
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["birthday-sale-urgency-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  var SELECTOR = '[data-birthday-sale-urgency]';

  function pad(value) {
    var n = Math.max(0, Math.floor(value));
    return n < 10 ? '0' + n : String(n);
  }

  function initComponent(root) {
    if (!root || root.dataset.bsuInitialised === 'true') return;
    root.dataset.bsuInitialised = 'true';

    var start = Date.parse(root.getAttribute('data-start-date'));
    var end = Date.parse(root.getAttribute('data-end-date'));

    if (isNaN(start) || isNaN(end) || end <= start) {
      root.setAttribute('data-state', 'inactive');
      return;
    }

    var progressStart = parseFloat(root.getAttribute('data-progress-start'));
    var progressEnd = parseFloat(root.getAttribute('data-progress-end'));
    if (isNaN(progressStart)) progressStart = 98;
    if (isNaN(progressEnd)) progressEnd = 8;

    var digits = {
      days: root.querySelectorAll('[data-countdown="days"]'),
      hours: root.querySelectorAll('[data-countdown="hours"]'),
      minutes: root.querySelectorAll('[data-countdown="minutes"]'),
      seconds: root.querySelectorAll('[data-countdown="seconds"]')
    };
    var bars = root.querySelectorAll('[data-progress-bar]');
    var timer = null;

    function setDigits(nodeList, value) {
      var text = pad(value);
      for (var i = 0; i < nodeList.length; i++) {
        if (nodeList[i].textContent !== text) nodeList[i].textContent = text;
      }
    }

    function render() {
      var now = Date.now();

      if (now < start || now >= end) {
        root.setAttribute('data-state', 'inactive');
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
        return;
      }

      root.setAttribute('data-state', 'active');

      var diff = (end - now) / 1000;
      setDigits(digits.days, diff / 86400);
      setDigits(digits.hours, (diff % 86400) / 3600);
      setDigits(digits.minutes, (diff % 3600) / 60);
      setDigits(digits.seconds, diff % 60);

      var ratio = Math.min(1, Math.max(0, (now - start) / (end - start)));
      var pct = progressStart - (progressStart - progressEnd) * ratio;

      for (var i = 0; i < bars.length; i++) {
        bars[i].style.width = pct + '%';
        var track = bars[i].parentNode;
        if (track && track.setAttribute) track.setAttribute('aria-valuenow', Math.round(pct));
      }
    }

    render();
    timer = setInterval(render, 1000);
  }

  function initAll(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    var nodes = context.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) initComponent(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
